import { z } from 'zod';

import { centsSchema } from '@nesso/common-contracts/cents';
import { defineCommand } from '@nesso/common-contracts/define';
import { practiceIdSchema, practiceMemberIdSchema } from '@nesso/common-contracts/ids';
import { metadata } from '@nesso/common-contracts/schema-metadata';

import { clientIdSchema, sessionChargeIdSchema } from './ids';

export const SESSION_CHARGE_INVOICE_DUE_TYPE = 'session-charge/invoice-due';
export const SESSION_CHARGE_CHANGE_FEE_TYPE = 'session-charge/change-fee';

export const sessionChargeInvoiceDue = defineCommand(SESSION_CHARGE_INVOICE_DUE_TYPE, z.object({}));

export const sessionChargeChangeFee = defineCommand(
    SESSION_CHARGE_CHANGE_FEE_TYPE,
    z.object({
        id: sessionChargeIdSchema.meta(metadata.nonSensitive),
        practiceId: practiceIdSchema.meta(metadata.nonSensitive),
        practiceMemberId: practiceMemberIdSchema.meta(metadata.nonSensitive),
        clientId: clientIdSchema.meta(metadata.nonSensitive),
        serviceCode: z.string().trim().min(1),
        feeCents: centsSchema,
        expected: z.object({
            serviceCode: z.string(),
            feeCents: centsSchema,
            paidCents: centsSchema,
        }),
    }),
    z.object({ id: sessionChargeIdSchema.meta(metadata.nonSensitive) }),
);
